import React from 'react'

import ResetPassword from 'components/ResetPassword/ResetPassword'

const ForgotPasswordPage: React.FC = () => {
  return <ResetPassword />
}

export default ForgotPasswordPage
